module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 272);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  1:
  /***/
  function _(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  2:
  /***/
  function _(module, exports) {
    module.exports = require("classnames");
    /***/
  },

  /***/
  272:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _ToolbarButton = __webpack_require__(273);

    Object.defineProperty(exports, 'ToolbarButton', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ToolbarButton).default;
      }
    });

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    /***/

  },

  /***/
  273:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    exports.default = ToolbarButton;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _noop = __webpack_require__(4);

    var _noop2 = _interopRequireDefault(_noop);

    var _classnames = __webpack_require__(2);

    var _classnames2 = _interopRequireDefault(_classnames);

    var _color = __webpack_require__(274);

    var _color2 = _interopRequireDefault(_color);

    var _fill = __webpack_require__(275);

    var _fill2 = _interopRequireDefault(_fill);

    var _general = __webpack_require__(276);

    var _general2 = _interopRequireDefault(_general);

    var _hover = __webpack_require__(277);

    var _hover2 = _interopRequireDefault(_hover);

    var _position = __webpack_require__(278);

    var _position2 = _interopRequireDefault(_position);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var BUTTON_SIZE = 34;

    function ToolbarButton(_ref) {
      var children = _ref.children,
          color = _ref.color,
          fill = _ref.fill,
          hover = _ref.hover,
          icon = _ref.icon,
          isDisabled = _ref.isDisabled,
          isOpaque = _ref.isOpaque,
          isSlim = _ref.isSlim,
          onClick = _ref.onClick,
          position = _ref.position;
      var buttonClasses = (0, _classnames2.default)(_color2.default[color], _fill2.default[fill], _general2.default.button, _hover2.default[hover], _position2.default[position], _defineProperty({}, _general2.default.isDisabled, isDisabled));
      var wrapClasses = (0, _classnames2.default)(_defineProperty({}, _general2.default.isOpaque, isOpaque));
      var baseStyle = {
        height: BUTTON_SIZE,
        lineHeight: BUTTON_SIZE + 'px'
      };
      var spacingStyle = !isSlim && {
        paddingLeft: icon ? BUTTON_SIZE : 10,
        paddingRight: children ? 10 : 0
      };

      var buttonStyle = _extends({}, baseStyle, spacingStyle);

      var iconStyle = icon && {
        width: BUTTON_SIZE,
        height: BUTTON_SIZE
      };
      return _react2.default.createElement('div', {
        className: buttonClasses,
        style: buttonStyle,
        onClick: onClick
      }, _react2.default.createElement('div', {
        className: wrapClasses
      }, icon && _react2.default.createElement('div', {
        className: _general2.default.iconWrap,
        style: iconStyle
      }, _react2.default.createElement('div', {
        className: _general2.default.icon
      }, icon)), children));
    }

    ToolbarButton.propTypes = {
      children: _propTypes2.default.node,
      color: _propTypes2.default.oneOf(Object.keys(_color2.default)),
      fill: _propTypes2.default.oneOf(Object.keys(_fill2.default)),
      hover: _propTypes2.default.oneOf(Object.keys(_hover2.default)),
      icon: _propTypes2.default.node,
      isDisabled: _propTypes2.default.bool,
      isOpaque: _propTypes2.default.bool,
      isSlim: _propTypes2.default.bool,
      onClick: _propTypes2.default.func,
      position: _propTypes2.default.oneOf(Object.keys(_position2.default))
    };
    ToolbarButton.defaultProps = {
      color: 'slate',
      fill: 'smoke--xd',
      hover: 'background',
      icon: null,
      isDisabled: false,
      isOpaque: false,
      isSlim: false,
      onClick: _noop2.default,
      position: 'solo'
    };
    /***/
  },

  /***/
  274:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "silver": "color__silver___3tnHZ c-silver",
      "slate": "color__slate___1n2cC c-slate",
      "smoke": "color__smoke___3hMHf c-smoke"
    };
    /***/
  },

  /***/
  275:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "smoke": "fill__smoke___2nra2 fill-smoke",
      "smoke--d": "fill__smoke--d___2t1sd fill-smoke--d",
      "smoke--xd": "fill__smoke--xd___2mqKO fill-smoke--xd",
      "silver": "fill__silver___xFGjj fill-silver"
    };
    /***/
  },

  /***/
  276:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "button": "general__button___1ugJt cursor-pointer display-inlineBlock fontSize-s position-relative transitionDuration-l transitionProperty-all transitionTimingFunction-cb--scaleOut",
      "iconWrap": "general__iconWrap___1ynVs pinTL position-absolute",
      "icon": "general__icon___jL08a pinCenter position-absolute",
      "isDisabled": "general__isDisabled___1JLrl pointerEvents-none",
      "isOpaque": "general__isOpaque___2H609 opacity-40"
    };
    /***/
  },

  /***/
  277:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "background": "hover__background___1Vfco",
      "color": "hover__color___VgG2E c-blue--hover fill-blue--hover"
    };
    /***/
  },

  /***/
  278:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "solo": "position__solo___iTu-P borderRadius-s",
      "end": "position__end___2mhEK borderRadiusRight-s",
      "left": "position__left___1m8MA borderRadiusLeft-s",
      "right": "position__right___11xul borderRadiusRight-s",
      "middle": "position__middle___2yEMj"
    };
    /***/
  },

  /***/
  4:
  /***/
  function _(module, exports) {
    module.exports = require("lodash/noop");
    /***/
  }
  /******/

});